/** @jsx jsx */
import { jsx } from '@emotion/core'

import { LoadSpinWrap } from '@styles/base.style'
import { BaseballIco, BasketballIco, SoccerIco, VolleyballIco } from '@shared/Icon/SportsIcon'

function PageLoading() {
  return (
    <LoadSpinWrap>
      <span className="shadow"/>
      <span className="ball-wrapper">
        <SoccerIco/>
        <BasketballIco/>
        <BaseballIco/>
        <VolleyballIco/>
      </span>
    </LoadSpinWrap>
  )
}

export default PageLoading
